export const LEVEL_TYPES = {
  FEDERAL: 1,
  REGIONAL: 2,
  MUNICIPAL: 3,
  LOCAL: 4,
};

export const LEVEL_NAMES = {
  [LEVEL_TYPES.FEDERAL]: 'Федеральный',
  [LEVEL_TYPES.REGIONAL]: 'Региональный',
  [LEVEL_TYPES.MUNICIPAL]: 'Муниципальный',
  [LEVEL_TYPES.LOCAL]: 'Локальный',
};

export const LEVEL_TYPES_LIST = Object.values(LEVEL_TYPES);
